import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-sort.tsx
/**
* icon.24.sort
*
* Keywords: descending, down, arrow, list, ordering, vertical, sequence, downward
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTcuNSA2YS41LjUgMCAwIDEgLjUuNXY5Ljc5M2wxLjE0Ni0xLjE0NmEuNS41IDAgMCAxIC43MDcuNzA3bC0yIDJhLjUuNSAwIDAgMS0uNzA3IDBsLTItMi0uMDY0LS4wNzlhLjUuNSAwIDAgMSAuNjkzLS42OTNsLjA3OC4wNjRMNyAxNi4yOTNWNi41YS41LjUgMCAwIDEgLjUtLjVtMTAgMTBhLjUuNSAwIDAgMSAwIDFoLTVhLjUuNSAwIDAgMSAwLTF6bTAtM2EuNS41IDAgMCAxIDAgMWgtNWEuNS41IDAgMCAxIDAtMXptMC0zYS41LjUgMCAwIDEgMCAxaC01YS41LjUgMCAwIDEgMC0xem0wLTNhLjUuNSAwIDAgMSAwIDFoLTVhLjUuNSAwIDAgMSAwLTF6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=3692-104257
*/
const Icon24Sort = memo(function Icon24Sort(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M7.5 6a.5.5 0 0 1 .5.5v9.793l1.146-1.146a.5.5 0 0 1 .707.707l-2 2a.5.5 0 0 1-.707 0l-2-2-.064-.079a.5.5 0 0 1 .693-.693l.078.064L7 16.293V6.5a.5.5 0 0 1 .5-.5m10 10a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0-3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0-3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0-3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z"
		})
	});
});
//#endregion
export { Icon24Sort };

//# sourceMappingURL=icon-24-sort.js.map